<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "pompUsername":"aketest"
           },
            responseCode:  {
                "data": {
                    "parks": [
                        {
                            "name": "智慧岗亭开发测试",
                            "parkCode": "PRKKKRRC",
                            "parkSysType": 1
                        },
                        {
                            "name": "test_test3",
                            "parkCode": "PRIRST2G",
                            "parkSysType": 0
                        }
                    ]
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },
            infoData: {
                explain: "根据POMP用户账号获取POMP数据权限",
                t_url: this.commonUrls.test+"getPOMPAuthzParks",
                p_url: this.commonUrls.prod+"getPOMPAuthzParks",
                precondition: "授权商拥有的车场权限必须全包含POMP账号的车场权限，否则返回“车场权限不足”",
                fitSystem: "POMP",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'pompUsername', info2: '是', info3: 'String', info4: 'pomp登陆账号' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '车场编号' },
                        { info1: 'name', info2: '是', info3: 'String', info4: '车场名称' },
                        { info1: 'parkSysType', info2: '是', info3: 'int', info4: '车场系统类型（0:传统停车场，1:云停车场，2:第三方停车场）' }
                        ]
                    },
                ]
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/other/getPOMPAuthzParks.vue